import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

const prepareList = data => {
  const list = [];

  data.forEach(item => {
    const el = {
      key: item.product_type,
      ...item
    };
    list.push(el);
  });

  return list;
};

function* getShopifyProductTypes({ payload: { signal, searchQ, curr_page } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.shopify.search_product_types,
      params: { page: curr_page, query: searchQ },
      signal
    });

    const preparedData = {
      dataTable: prepareList(data.results),
      message: data.message,
      count: data.count,
      next: data.next,
      previous: data.next
    };

    yield put(actions.getShopifyProductTypesDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getShopifyProductTypesFailed,
      endpoint: api.shopify.search_product_types.url
    });
  }
}

export const getShopifyProductTypesSaga = takeEvery(types.GET_SHOPIFY_PRODUCT_TYPES_REQUEST, getShopifyProductTypes);
